export const setAll = (state, all) => {
  state.all = all;
};
